import styled from '@emotion/styled';
import { Checkbox, Tooltip, theme } from '@landsbankinn/ui';
import React from 'react';
import type {
  RequestGdprDataInput,
  RequestGdprDataType,
} from '../../../../__generated__/globalTypes';

interface IProps {
  label: string;
  setGdprData: React.Dispatch<React.SetStateAction<RequestGdprDataInput>>;
  gdprData: RequestGdprDataInput;
  type: RequestGdprDataType;
  tooltipText?: string;
  tooltipTitle?: string;
}
const Host = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  & > * + * {
    margin-left: 12px;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  background: transparent;
`;

export function GdprCheckbox({
  label,
  setGdprData,
  gdprData,
  type,
  tooltipText,
  tooltipTitle,
}: IProps) {
  return (
    <Host>
      <StyledCheckbox
        label={label}
        id={type}
        checked={gdprData.types.includes(type)}
        variant="noBorder"
        onChange={(checked) => {
          if (checked) {
            setGdprData({
              ...gdprData,
              types: [...gdprData.types, type],
            });
          } else {
            setGdprData({
              ...gdprData,
              types: gdprData.types.filter((i) => i !== type),
            });
          }
        }}
      />
      <Tooltip
        useQuestionMark
        title={tooltipTitle}
        copy={tooltipText}
        bg={theme.shades.secondary2}
      />
    </Host>
  );
}
